import { isNullish, Text, TooltipWrapper, Icon, Flex } from "@theorgchartdev/storybook";
import { FormatFieldValue } from "@coreapp/utils/FormatFieldValue";
import { appstr } from "@coreapp/utils/appstr";
import { kBlockedFieldTag } from "@coreapp/constants";

export const CurrentMetricText = ({ rowState }) => {
  const baseValue = rowState?.data?.starting;
  const currentValue = rowState?.data?.current;
  const hasBlockedValue = currentValue === kBlockedFieldTag;
  const fieldDef = rowState?.data?.fieldDef;
  const value = hasBlockedValue
    ? kBlockedFieldTag
    : isNaN(currentValue) || isNullish(currentValue)
      ? 0
      : currentValue;

  const fullValue = FormatFieldValue(value, fieldDef);
  const compactValue = FormatFieldValue(value, fieldDef, null, 5, true);

  const delta = (baseValue - currentValue) * -1;
  let tooltipMessage = hasBlockedValue ? appstr("blockedmetrictip") : fullValue;

  // Show trend arrow if there's a delta from starting value
  const showTrendArrow = Math.abs(delta) >= 1;
  const isTrendingUp = delta > 0;

  // Build trend tooltip
  let trendTooltipProps = undefined;
  if (showTrendArrow) {
    const fullStartingValue = FormatFieldValue(baseValue, fieldDef);
    const fullDelta = FormatFieldValue(Math.abs(delta), fieldDef);
    const deltaSign = delta > 0 ? "+" : "-";

    trendTooltipProps = {
      message: appstr("Metric trend tooltip", {
        starting: fullStartingValue,
        delta: `${deltaSign}${fullDelta}`
      })
    };
  }

  return (
    <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <TooltipWrapper tooltipProps={{ message: tooltipMessage }}>
        <Flex direction={"row"} alignItems={"center"} gap={"6px"}>
          {hasBlockedValue && (
            <Icon name={"triangle-exclamation"} modifier={"warning"} size={"xsmall"} />
          )}
          <Text colorModifier={"gray"} size={"xsmall"}>
            {compactValue}
          </Text>
        </Flex>
      </TooltipWrapper>
      {showTrendArrow && (
        <TooltipWrapper tooltipProps={trendTooltipProps}>
          <Icon
            name={isTrendingUp ? "arrow-trend-up" : "arrow-trend-down"}
            size="xsmall"
            layout="default"
          />
        </TooltipWrapper>
      )}
    </span>
  );
};
